/**
 * @file paddle Wave Summit 2020 活动卡片
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, { useMemo } from 'react';
import { Advprops } from './type';
import './style.less'

const ActiveList: React.FC<Advprops> = (props) => {
    const list = useMemo(() => {
        return props.list || [];
    }, [props.list]);




    return (
        <div className="paddlenlp-core">

            <div className="advantage-card-wrapper">
                {
                    list.map(item =>
                        <div className="paddlenlp-all">
                            <div className="paddlenlp-background">
                                <div
                                    className="paddlenlp-picture-card-img"
                                    style={{ backgroundImage: item.imageUrl ? `url(${item.imageUrl})` : undefined }}
                                />
                            </div>
                            <div className="paddlenlp-advantage-content">
                                <p className="content-title-h">{item.title}</p>
                            </div>
                        </div>

                    )
                }

            </div>

        </div>
    );
};

export default ActiveList;
